import React from "react";

import ServerGuide, {
    GeneralCancelCommandNotes,
    GeneralUsingNativeApiNotes,
    GeneralNativeConnectionHandles,
    GeneralNativeCommandHandles,
    GenericPosNotSupportedErrorNotes
} from "../../components/server-guide";
import {Callout} from "../../components/alert";
import {CodeSnippet} from "../../components/snippet";
import {CodeRef} from "../../components/code";
import {ApiLink} from "../../components/link";
import {options} from "../../data/oledb";

const connectApiNotes = () => (
    <Callout heading="Minimum Version">
        SQLAPI++ library requires OLEDB version 2.0 or higher.
    </Callout>
);

const sDBString = () => (
    <>
        <div>A connection string like</div>
        <CodeSnippet>
            {`[<provider_string>!][<server_name>@][<database_name>][;<driver_connection_option_list>]`}
        </CodeSnippet>

        <ul>
            <li>
                <CodeRef>{`<provider_string>`}</CodeRef>{' '} - OLEDB provider string, for example{' '} 
                <CodeRef>{`Microsoft.ACE.OLEDB.12.0`}</CodeRef>
            </li>
            <li>
                <CodeRef>{`<server_name>`}</CodeRef>{' '} - connects to a specified server (DBPROP_INIT_DATASOURCE)
            </li>
            <li>
                <CodeRef>{`<database_name>`}</CodeRef>{' '} - connects to a database with the specified name (DBPROP_INIT_CATALOG)
            </li>
            <li>
                <CodeRef>{`<driver_connection_parameters_list>`}</CodeRef>{' '} - OLEDB driver specific
                parameters list (DBPROP_INIT_PROVIDERSTRING)
            </li>
        </ul>
    </>
);

const UserID = () => (<p>A string containing a user name to use when establishing the connection.</p>);

const OutputParamNotes = () => (
    <>
        <p>
            SQLAPI++ library automatically creates {' '}<ApiLink>SAParam</ApiLink>{' '} object to represent function
            return value.
            You can refer to this {' '}<ApiLink>SAParam</ApiLink>{' '} object using SQLAPI++ predefined
            name <code>"RETURN_VALUE"</code>.
        </p>
    </>
);

const Page = () => (
    <ServerGuide server="OLEDB"
                 connectApiNotes={connectApiNotes}
                 sDBString={sDBString}
                 sUserID={UserID}
                 outputParamNotes={OutputParamNotes}
                 cancelCommandNotes={() => <GeneralCancelCommandNotes server="OLEDB"
                                                                      nativeCommand="ICommand::Cancel"/>}
                 options={options}
                 usingNativeApiNotes={() => <GeneralUsingNativeApiNotes server="OLEDB"
                                                                        cppHeader="oledbAPI.h"
                                                                        apiClass="oledbAPI"/>}
                 nativeConnectionHandles={() => <GeneralNativeConnectionHandles server="OLEDB"
                                                                                handleClass="oledbConnectionHandles"
                                                                                cppHeader="oledbAPI.h"/>}
                 nativeCommandHandles={() => <GeneralNativeCommandHandles server="OLEDB"
                                                                          handleClass="oledbCommandHandles"
                                                                          cppHeader="oledbAPI.h"/>}
                 errorNotes={() => <GenericPosNotSupportedErrorNotes server="OLEDB"/>}
    />
);

export default Page;
